import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import api from "@/lib/api";
import PublicLayout from "@/components/PublicLayout";

export function IndustriesIndex() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/industries").then((r) => setItems(r.data || [])); }, []);
  return (
    <PublicLayout>
      <section className="border-b border-[var(--border)] bg-white py-16 sm:py-24" data-testid="industries-index">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
          <Link to="/" className="btn-ghost mb-6 inline-flex" data-testid="industries-back">
            <ArrowLeft size={12} /> Home
          </Link>
          <div className="eyebrow">Industry Coverage</div>
          <h1 className="font-display font-black text-[clamp(2.4rem,6vw,5rem)] mt-4 leading-[0.95] tracking-tight text-[var(--navy)]">
            Twelve high-growth industries.
          </h1>
          <p className="mt-6 font-display italic text-2xl text-[var(--slate)] max-w-3xl">
            Specialty chemicals, packaging, energy transition, semiconductors, manufacturing,
            and the emerging-technology verticals reshaping the next decade of capital allocation.
          </p>

          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((i, idx) => (
              <Link
                key={i.slug}
                to={`/industries/${i.slug}`}
                className="group block bg-white border border-[var(--border)] hover-lift"
                data-testid={`industry-card-${i.slug}`}
              >
                <div className="relative aspect-[16/10] overflow-hidden bg-[var(--navy)]">
                  {i.hero_image && (
                    <img src={i.hero_image} alt={i.name} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-[1.02] transition-all duration-500" />
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-[var(--navy)]/70 via-transparent to-transparent" />
                  <div className="absolute top-3 left-3 text-[10px] font-mono uppercase tracking-[0.2em] text-[var(--gold)]">
                    No. {String(idx + 1).padStart(2, "0")}
                  </div>
                  <div className="absolute bottom-3 left-3 right-3">
                    <h3 className="font-display font-bold text-white text-2xl leading-tight">{i.name}</h3>
                  </div>
                </div>
                <div className="p-5">
                  <p className="text-sm text-[var(--slate)] leading-relaxed">{i.tagline}</p>
                  <div className="mt-4 grid grid-cols-2 gap-3 text-[11px] font-mono uppercase">
                    <div>
                      <div className="text-[var(--slate-light)]">Mkt</div>
                      <div className="text-[var(--navy)] text-base">${i.market_size_usd_b}B</div>
                    </div>
                    <div>
                      <div className="text-[var(--slate-light)]">CAGR</div>
                      <div className="text-[var(--gold)] text-base">{i.cagr_pct}%</div>
                    </div>
                  </div>
                  <div className="mt-5 pt-4 border-t border-[var(--border)] text-[11px] font-mono uppercase tracking-[0.18em] text-[var(--navy)] flex items-center justify-between">
                    <span>Intelligence Coverage</span>
                    <ArrowUpRight size={12} className="text-[var(--gold)] group-hover:translate-x-0.5 transition-transform" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
